/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable camelcase */
/* eslint-disable id-length */
import React from 'react'
import { Card, CardContent, Grid, Typography } from '@mui/material'
import { LineChart } from '@mui/x-charts'
import { useLang } from '~/hooks/useLang'

export default function LineChartMui({
  data,
  title,
  subtitle = '',
  sxFont = {},
  typeTotal = '',
  marginLeft = 70,
  shouldEnableScroll = false,
}) {
  const { translate } = useLang()
  const xFieldTreatament = data.map((element) => String(element.item))
  const dataTreatament = data.map((element) => element.value)
  
  const itemCount = xFieldTreatament.length
  const hasManyItems = itemCount >= 15

  // Cálculo do espaçamento entre itens
  const itemSpacing = itemCount > 20 ? 40 : itemCount > 10 ? 35 : 30

  // Cálculo do tamanho da fonte dos labels
  const getFontSize = () => {
    if (!shouldEnableScroll) return itemCount >= 10 ? 11 : 12
    if (itemCount >= 20) return 10
    if (itemCount >= 10) return 11
    return 12
  }

  // Cálculo da largura do gráfico
  const getChartWidth = () => {
    if (!shouldEnableScroll) return undefined
    if (hasManyItems) return Math.max(100, itemCount * itemSpacing)
    return undefined
  }

  // Calcula o tamanho do maior label para ajustar margem inferior
  const getMaxLabelLength = () => {
    const maxLength = Math.max(...xFieldTreatament.map(item => item.length))
    // Para textos longos (>30 chars), precisa mais espaço
    if (maxLength > 60) return 350
    if (maxLength > 50) return 320
    if (maxLength > 30) return 240
    if (maxLength > 20) return 200
    return 180
  }

  // Cálculo das margens do gráfico
  const getMargins = () => {
    const baseMargins = { top: 25, left: marginLeft }
    const minBottomMargin = getMaxLabelLength()

    if (!shouldEnableScroll) {
      return { ...baseMargins, bottom: Math.max(100, minBottomMargin - 100), right: 50 }
    }

    if (hasManyItems) {
      return {
        ...baseMargins,
        bottom: Math.max(minBottomMargin, itemCount * 10),
        right: Math.max(150, itemCount * 3),
      }
    }

    // Para poucos itens (2-14) com scroll habilitado
    return { 
      ...baseMargins, 
      bottom: minBottomMargin, 
      right: itemCount <= 4 ? Math.max(120, itemCount * 25) : 50 
    }
  }

  const getGridStyle = () => {
    if (!shouldEnableScroll) return {}
    return {
      width: '100%',
      height: '600px',
      overflow: 'auto',
      paddingBottom: '120px',
    }
  }

  return (
    <Card
      variant="outlined"
      sx={shouldEnableScroll ? {} : { height: 600, overflowX: 'auto' }}
    >
      <CardContent sx={shouldEnableScroll ? {} : { height: '80%' }}>
        <Typography sx={{ fontWeight: 'bold', ...sxFont }}>
          {translate(title)}
        </Typography>
        {subtitle && (
          <Typography variant="subtitle2" marginBottom={2} marginTop={1}>
            {translate(subtitle)}
            {typeTotal &&
              `| ${translate('Total of')} ${translate(typeTotal)}: ${itemCount}`}
          </Typography>
        )}
        {data.length ? (
          <Grid sx={getGridStyle()}>
            <LineChart
              series={[{ curve: 'linear', data: dataTreatament }]}
              xAxis={[
                {
                  scaleType: 'point',
                  data: xFieldTreatament,
                  tickPlacement: 'middle',
                  tickLabelPlacement: 'tick',
                  tickLabelStyle: {
                    fontSize: getFontSize(),
                    angle: 40,
                    textAnchor: 'start',
                  },
                },
              ]}
              width={getChartWidth()}
              height={shouldEnableScroll ? 600 : 500}
              skipAnimation
              grid={{ horizontal: true }}
              margin={getMargins()}
              leftAxis={{ labelStyle: { fontSize: 10 } }}
            />
          </Grid>
        ) : (
          <Grid item sx={{ height: '100%' }}>
            <Card
              variant="outlined"
              sx={{
                display: 'flex',
                height: '100%',
                width: '100%',
                alignItems: 'center',
                justifyContent: 'center',
                border: 'none',
              }}
            >
              <CardContent>
                <Typography>{translate('No data available')}</Typography>
              </CardContent>
            </Card>
          </Grid>
        )}
      </CardContent>
    </Card>
  )
}
